import { render, staticRenderFns } from "./SubCategoryForm.vue?vue&type=template&id=147ce624&"
import script from "./SubCategoryForm.vue?vue&type=script&lang=ts&"
export * from "./SubCategoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./SubCategoryForm.vue?vue&type=style&index=0&id=147ce624&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports